import dynamic from 'next/dynamic'
import React from 'react'

import Box from 'app/components/base/Box'

const TrianglesSVG = dynamic(
  () => import('app/assets/images/auth-triangles.svg'),
  {
    ssr: false
  }
)

interface TrianglesContainerProps {
  customPattern?: React.ReactNode
}

const TrianglesContainer: RFC<TrianglesContainerProps> = ({
  children,
  customPattern
}) => {
  return (
    <Box
      position="relative"
      sx={{
        display: 'flex',
        flex: 1,
        height: '100%'
      }}
    >
      <Box
        sx={{
          display: 'grid',
          justifyContent: 'center',
          overflow: 'hidden',
          position: 'absolute',
          width: '100%',
          left: 0,
          right: 0,
          top: 0,
          zIndex: -1
        }}
      >
        {customPattern || <TrianglesSVG />}
      </Box>

      {children}
    </Box>
  )
}

export default TrianglesContainer
